import React from 'react'

const Branches: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-gray-900">Chi nhánh</h1>
      <p>Coming soon</p>
    </div>
  )
}

export default Branches 